<div class="achoo-tabs">
  <header>
    <div class="material-tabs">
      <div class="material-header-container">
        <a tabLabelWrapper *ngFor="let tab of tabs;let inx = index"
          (click)="selectTab(tab, false)"
          [ngClass]="{'selected': tab.active, 'tab-label-content': true, 'influencer-tab': tab.isInfluencerTab}"
          [attr.tab-key]="tab.tabKey || 'tab'+inx">
          <span [ngTransclude]="tab.tabHeading?.templateRef">{{tab.textLabel}}</span>
        </a>
        <span class="tab-ink-bar" tabInkBar></span>
      </div>
    </div>
  </header>
  <ng-content></ng-content>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-tabs/achoo-tabs.component.html